import indexOf from "lodash/indexOf";
import map from "lodash/map";
import axios from "../../../config/axios";
import Nota from "../modelo";

let listaNotas = [];

export default {
  obtenerPublica,
  getNotasCliente,
  getGraficos,
  getEntidadesBulkPublicas,
  getPersonajesBulkPublicas,
  getNextNota,
  getPrevNota,
};

function getNextNota(id) {
  if (id) {
    const notas = listaNotas;
    const index = indexOf(notas, id);
    if (index !== -1 && (index + 1 !== notas.length)) {
      return notas[index + 1];
    }
    return id;
  }
  return null;
}

function getPrevNota(id) {
  if (id) {
    const notas = listaNotas;
    const index = indexOf(notas, id);
    if (index !== -1 && (index - 1 !== -1)) {
      return notas[index - 1];
    }
    return id;
  }
  return null;
}

function obtenerPublica(id) {
  if (id) {
    return axios
      .get(`${axios.defaults.baseUrl}/api/notaPublica/${id}`)
      .then(resp => Nota(resp.data));
  }
  return {};
}

function getNotasCliente(
  cliente, fInicio, fFin, tipoMencion, tipoMedio, texto, yaCargados, limite,
  opciones) { // eslint-disable-line
  const body = {
    cliente: cliente || false,
    fechaInicio: fInicio || null,
    fechaFin: fFin || null,
    tipoMencion: tipoMencion || {},
    tipoMedio: tipoMedio || {},
    texto: texto || null,
    yaCargados: yaCargados || 0,
    limite: limite || 0,
  };
  return axios
    .post(`${axios.defaults.baseUrl}/api/guion/getGuiones/`, body, opciones)
    .then(resp => resp.data, err);
}

function getGraficos(cliente, filtros) {
  const query = filtros ? {
    params: {
      cliente,
      fechaInicio: filtros.desde,
      fechaFin: filtros.hasta,
      tipoMencion: filtros.menciones,
      tipoMedio: filtros.medios,
      texto: filtros.texto,
    },
  } : { params: { cliente } };
  return axios
    .get(`${axios.defaults.baseUrl}/api/nota/graficos/${cliente}`, query)
    .then(ok, err);
}

function ok(resp) {
  if (resp.data.docs) {
    resp.data.docs = map(resp.data.docs, Nota);
    listaNotas = map(resp.data.docs, "_id");
  }
  return resp.data;
}

function err() {
  return [];
}

function getEntidadesBulkPublicas(ids) {
  return axios
    .post(`${axios.defaults.baseUrl}/api/notaPublica/entidades`, ids)
    .then(resp => resp.data);
}

function getPersonajesBulkPublicas(ids) {
  return axios
    .post(`${axios.defaults.baseUrl}/api/notaPublica/personajes`, ids)
    .then(resp => resp.data);
}



// WEBPACK FOOTER //
// ./src/components/notas/rest/notasApi.js